module.exports = __webpack_public_path__ + "img/img_project_content1.694db42b.svg";